import { render, staticRenderFns } from "./CityPriceEditor.vue?vue&type=template&id=52d9b79a&"
import script from "./CityPriceEditor.vue?vue&type=script&lang=js&"
export * from "./CityPriceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports